import { getSavedPicks } from "@/lib/local-storage";
import { bulkImportPicks } from "@/lib/saved-picks.functions";

const MIGRATED_KEY = "usalotteryclub_picks_migrated_v1";

/**
 * On first sign-in: push any locally-saved picks to the cloud, then mark migrated.
 * Safe to call repeatedly — no-op once flagged.
 */
export async function migrateLocalPicksToCloud(): Promise<void> {
  try {
    if (typeof window === "undefined") return;
    if (localStorage.getItem(MIGRATED_KEY) === "1") return;
    const local = getSavedPicks();
    if (local.length === 0) { localStorage.setItem(MIGRATED_KEY, "1"); return; }
    await bulkImportPicks({
      data: {
        picks: local.map((p) => ({
          game_slug: p.gameSlug,
          game_name: p.gameName,
          numbers: p.numbers,
          bonus_numbers: p.bonusNumbers ?? [],
          label: p.label ?? null,
        })),
      },
    });
    localStorage.setItem(MIGRATED_KEY, "1");
  } catch (e) {
    console.warn("Failed to migrate local picks", e);
  }
}